module.exports = __webpack_public_path__ + "pc/img/img_about_01.70fe264c.png";